import { Accordion } from '@zaiusinc/hera';
import React, { useState, useEffect, ReactNode } from 'react';
import styles from './CustomSettingsSection.module.sass';

interface Props {
  title: string;
  sectionKey: string;
  isOpen?: boolean;
  onToggle?: () => void;
  children: ReactNode;
}

export const CustomSettingsSection = ({
  title,
  sectionKey,
  isOpen = false,
  onToggle,
  children,
}: Props) => {
  const [sectionOpen, setSectionOpen] = useState(isOpen);

  useEffect(() => {
    setSectionOpen(isOpen);
  }, [isOpen]);

  const handleClick = () => {
    // Only open the section if it's closed (match app form section behavior)
    // Don't close when clicking on an already open section
    if (!sectionOpen && onToggle) {
      onToggle();
    }
  };

  return (
    <Accordion
      className={styles.section}
      minimal={true}
      isOpen={sectionOpen}
      header={title}
      onClick={handleClick}
    >
      <div className={styles.content}>
        {children}
      </div>
    </Accordion>
  );
};
